import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SetErrorBlock } from '../shared/set-error-block.model';

/**
 * Display warnings and errors. Clicking on an error block takes us to the set or current delivery.
 */
@Component({
    selector: 'app-error-warning-dialog',
    templateUrl: './error-warning-dialog.component.html',
    styleUrls: ['./error-warning-dialog.component.css'],
    standalone: false
})
export class ErrorWarningDialogComponent implements OnInit {

  disallowSubmission: boolean = false;
  hasErrors: boolean = false;

  constructor(public dialogRef: MatDialogRef<ErrorWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {errors: SetErrorBlock[], submission: boolean}) {
      this.disallowSubmission = data.submission && data.errors.some(er => er.isError);
      this.hasErrors = data.errors.some(er => er.isError);
     }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
